import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

function LaborExpert() {
  const cases = [
    'Kıdem tazminatı ve ihbar tazminatı alacakları',
    'Fazla çalışma ve fazla mesai ücretleri',
    'Yıllık izin ücreti alacakları',
    'Hafta tatili ve ulusal bayram ücretleri',
    'İşe iade davalarında boşta geçen süre ücreti',
    'Ücret alacakları ve ödenmeyen işçilik hakları',
  ];

  const steps = [
    'Dosyanın ve ücret, çalışma süresi belgelerinin incelenmesi',
    'Alacak kalemlerinin mevzuata ve yargı içtihatlarına göre hesaplanması',
    'Hesaplamaların gerekçeli bilirkişi raporu halinde hazırlanması',
    'Rapora ilişkin itirazların değerlendirilmesi ve gerekirse ek rapor',
  ];

  return (
    <main className="about">
      <SEO
        title="İş Hukuku Bilirkişisi | İzmir - TAMA & ORAL Hukuk Bürosu"
        description="İzmir'de iş hukuku bilirkişisi hizmeti. Kıdem tazminatı, fazla mesai ve işçilik alacakları hesaplaması ile gerekçeli bilirkişi raporu. TAMA & ORAL Hukuk Bürosu."
        keywords="iş hukuku bilirkişisi, iş hukuku bilirkişi, iş davası bilirkişi, bilirkişi raporu izmir, kıdem tazminatı hesaplama, işçilik alacakları bilirkişi, izmir avukat iş hukuku"
        canonical="https://tamaoral.av.tr/is-hukuku-bilirkisi"
      />

      <section className="page-header">
        <h1>İş Hukuku Bilirkişisi</h1>
      </section>

      <section className="about-content">
        <div className="about-section">
          <h2>İş Hukuku Bilirkişiliği Nedir?</h2>
          <p>
            İş hukuku bilirkişisi, iş davalarında mahkemenin talebi üzerine çalışma
            ilişkisinden doğan alacakları hesaplayan ve bu hesaplamaları gerekçeli
            bir rapor halinde mahkemeye sunan uzmandır. TAMA & ORAL Hukuk Bürosu
            olarak İzmir ve çevresindeki iş davalarında bu hizmeti sunuyoruz.
          </p>
        </div>

        <div className="about-section">
          <h2>Hangi Durumlarda Bilirkişi İncelemesi Gerekir?</h2>
          <ul>
            {cases.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </div>

        <div className="about-section">
          <h2>Bilirkişi Raporu Süreci</h2>
          <ol>
            {steps.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ol>
        </div>

        <div className="about-section">
          <h2>İş Davanız İçin Bilgi Alın</h2>
          <p>
            İş hukuku bilirkişisi ihtiyacınız veya iş davanızla ilgili sorularınız için
            bizimle iletişime geçebilirsiniz.
          </p>
          <Link to="/contact" className="cta-button">
            <span>Bize Ulaşın</span>
            <span className="button-arrow">→</span>
          </Link>
        </div>
      </section>
    </main>
  );
}

export default LaborExpert;
